export default "__VITE_ASSET__c6d78fc6__"